/* ============
 * State of the auth module
 * ============
 *
 * The initial state of the auth module.
 */

export default {
  authenticated: false,
  authenticatedDeskRh: false,
  authenticatedDeskDaf: false,
  authenticatedEdocSign: false,
  session: {
    token: undefined,
    login: undefined,
  },
  tokenDeskDaf: undefined,
  tokenEdocSign: undefined,
  domains: [],
  drhAdminCredentials: undefined,
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/state.js